import React from "react";
import { Container } from "react-bootstrap";
import "../assets/css/ContentScreens.css";

const BylawsScreen = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Container className="content-screen">
      <h1 className="text-center">Bylaws of Ellicottville Ski Club, Inc.</h1>
      <h2 className="text-center">Adopted October 7, 2023</h2>

      <section className="table-of-contents">
        <h3>TABLE OF CONTENTS</h3>
        <ol>
          <li onClick={() => scrollToSection("article-1")}>
            ARTICLE I - MEMBERS
          </li>
          <li onClick={() => scrollToSection("article-2")}>
            ARTICLE II - BOARD OF DIRECTORS
          </li>
          <li onClick={() => scrollToSection("article-3")}>
            ARTICLE III - COMMITTEES
          </li>
          <li onClick={() => scrollToSection("article-4")}>
            ARTICLE IV - OFFICERS
          </li>
          <li onClick={() => scrollToSection("article-5")}>
            ARTICLE V - INDEMNIFICATION AND INSURANCE
          </li>
          <li onClick={() => scrollToSection("article-6")}>
            ARTICLE VI - GENERAL
          </li>
          <li onClick={() => scrollToSection("article-7")}>
            ARTICLE VII - AMENDMENTS
          </li>
        </ol>
      </section>

      <section>
        <h5 className="text-center">PREAMBLE</h5>
        <p className="text-center mb-5">
          Ellicottville Ski Club, Inc. ("the Club") is a New York Not-For-Profit
          Corporation established for the primary purposes of providing social
          and athletic activities for Club members and their guests and
          promoting the advancement and improvement of the sport of skiing and
          other winter sports, scheduling ski competitions, and promoting good
          fellowship among skiers.
        </p>
      </section>

      <section id="article-1">
        <h2>ARTICLE I - MEMBERS</h2>
        <h4>Section 1. Members Authorized</h4>
        <p>
          The Club shall have three (3) classes of Members as follows: General,
          Honorary, and Non-Resident, collectively "the Member[s]."
        </p>

        <h4>Section 1.1 General Members</h4>
        <p>
          Any person twenty-one (21) years of age or older shall be eligible for
          General Membership. Whenever a married person or person living in a
          domestic partnership desires to apply for General Membership, it shall
          henceforth be required that both spouses/domestic partners must
          individually complete and submit an application for General
          Membership. The applications of spouses/domestic partners for General
          Membership shall be voted upon by the Board of Directors as a single
          joint application. In the event an applicant's spouse/domestic partner
          does not desire to become a General Member, the applicant may request
          that the Board of Directors consider a waiver of the requirement that
          both spouses/domestic partners must apply for General Membership. In
          the event an existing General Member shall subsequently marry or
          become a domestic partner, the spouse/domestic partner of the General
          Member, in order to be entitled to full General Membership privileges,
          must make an application for General Membership. Spouses/domestic
          partners who choose not to make an application for individual General
          Membership shall be considered to be a "Guest" as set forth herein in
          Section 7. All applications for membership or change in membership
          class shall be in writing in a format approved by the Board of
          Directors. To be considered for election to membership an application
          must be complete and filed within the time frame established by the
          Board of Directors. The number of General Members may be limited by
          the Board of Directors.
        </p>

        <h4>Section 1.2 Honorary Members</h4>
        <p>
          Any General Member may become an Honorary Member upon written
          application to and approval by the Board of Directors if that Member
          (i) is at least seventy-five (75) years of age and (ii) has been a
          General Member in good standing for at least twenty-five (25) years.
          Honorary Members shall enjoy all rights and privileges of General
          Members, except they may not be elected to the Board of Directors and
          may not vote at any meeting of Members. All applications for change in
          membership class shall be in writing to the Board of Directors
        </p>

        <h4>Section 1.3 Non-Resident Members</h4>
        <p>
          A Non-Resident Member shall be any General Member (i) who has first
          applied for and been admitted as a General Member and has paid the
          initiation fee required pursuant to these By-Laws, (ii) who is in good
          standing as a General Member, and (iii) whose written application for
          designation as a Non-Resident Member is approved by the Board of
          Directors. Non-Resident Members must reside at least 300 miles
          distance from Ellicottville and not maintain a residence in or around
          Ellicottville. A Non- Resident Member shall enjoy all rights and
          privileges of a General Member, except they may not be elected to the
          Board of Directors and may not vote at any meeting of Members. Upon
          residing within 300 miles of Ellicottville or maintaining a residence
          in or around Ellicottville, said Non-Resident Member shall be
          reclassified as a General Member. All applications for change in
          membership class shall be in writing to the Board of Directors.
        </p>

        <h4>Section 2. Sponsors</h4>
        <p>
          All applicants for membership must be sponsored by three (3) Members,
          each of whom has been a Member of the Club for at least five (5)
          years. No Member may sponsor more than one (1) applicant concurrently
          and no current member of the Board of Directors may sponsor an
          applicant for membership. If a Member sponsors an applicant and
          subsequently becomes a member of the Board of Directors, such Member
          shall withdraw his or her sponsorship of such applicant, effective as
          of the date on which such Member becomes a member of the Board of
          Directors.
        </p>

        <h4>Section 3. Election of Members</h4>
        <p>
          <p>
            General Members of the Club shall be elected by the Board of
            Directors by secret ballot from applications submitted in proper
            form and timely manner. All reports, proceedings, determinations,
            and actions in connection with the election of General Members shall
            be held in honorable secrecy. Two (2) adverse votes shall preclude
            any candidate from membership. Any adverse vote may be reconsidered
            at the same or any subsequent Board of Directors meeting. Membership
            shall be acted upon in the following order:
          </p>
          <ol>
            <li>New spouse/domestic partner of a member</li>
            <li>Children of members</li>
            <li>Past members wishing to rejoin the club</li>
            <li>New applicants</li>
          </ol>
        </p>
        <h4>Section 4. Initiation Fees and Dues</h4>
        <p>
          Upon election to membership, all new Members shall pay the initiation
          fee that has been established by the Board of Directors and is then in
          effect. All new General Members shall also pay the annual dues and any
          assessments payable by the General Members for the year of their
          election.
        </p>

        <h4>Section 5. Payment of Indebtedness</h4>
        <p>
          A statement setting forth indebtedness to the Club (dues and
          assessments, if any) will be rendered by mail, electronically, or by
          such other method as the Treasurer deems reasonable to each Member
          prior to October 15th of each year. Any Member whose dues or
          assessments have not been paid by November 15th may be dropped from
          membership in the Club. In no case will there be any refund of
          initiation fees, dues, or assessments (if any) paid.
        </p>

        <h4>Section 6. Discipline</h4>
        <p>
          Any Member or any immediate family of a Member whose conduct, in the
          sole discretion of the Board of Directors, is alleged to adversely
          affect or be likely to adversely affect the welfare or well-being of
          the Club or its Members, or whose continuance as a Member is alleged
          to be objectionable, shall be given the opportunity to promptly
          appear, either in person or by electronic communication, before the
          Board of Directors to discuss the basis for the allegation(s).
          Following the discussion as set forth above and upon an affirmative
          vote of two thirds (2/3) of the entire Board of Directors, the Board
          of Directors may impose such disciplinary measures as it deems
          appropriate, including the suspension or forfeiture of membership. In
          no case shall the disciplined Member be entitled to any refund of
          initiation fees, dues, or assessments (if any) paid.
        </p>

        <h4>Section 7. Guests</h4>
        <p>
          Subject to such House Rules as may be adopted by the Board of
          Directors, all Members in good standing shall have the privilege of
          bringing guests to the Club. While they are with their hosts, guests
          shall have full use of the Club's facilities, subject to the House
          Rules of the Club. Guest privileges must not be abused, and no one
          shall be allowed guest privileges in lieu of joining the Club. It
          shall be the duty of the Board of Directors to ensure that no abuse is
          made of guest privileges. Members shall be responsible for the conduct
          of guests and for any charges incurred by their guests.
        </p>

        <h4>Section 8. Children of Current Members</h4>
        <p>
          Subject to the House Rules of the Club, any child of a Member under
          twenty-one (21) years of age shall have full privileges for use of the
          Club's facilities. At the conclusion of the Holiday Valley ski season,
          any child of a Member who has attained twenty-one (21) years of age
          and has not already become a General Member in his or her own right
          shall cease to have full privileges for the use of the Club's
          facilities and shall be considered to be a "Guest" as that term is set
          forth in Article I Section 7 herein.
        </p>

        <h4>Section 9. Evidence of Membership</h4>
        <p>
          The Board of Directors may determine, in its sole discretion, the form
          of proof of membership, if any. Membership is not transferable.
        </p>
        <h4>Section 10. Annual Meeting of Members</h4>
        <p>
          A meeting of Members shall be held for the election of Directors and
          the transaction of other business between September 1st and December
          31st of each year on any day and time as determined by the Board of
          Directors or by the President. The Board of Directors shall present at
          the Annual Meeting of Members a written report verified by the
          President and Treasurer, or by a majority of the Directors, showing in
          appropriate detail the following:
        </p>
        <ol>
          <li>The assets and liabilities of the Club</li>
          <li>The principal changes in assets and liabilities</li>
          <li>The revenue or receipts of the Club</li>
          <li>
            The expenses or disbursements of the Club for both general and
            restricted purposes
          </li>
          <li>
            The number of Members of the Club as of the date of the report,
            together with a statement of increase or decrease in such number and
            a statement of where the names and places of residence of the
            current Members may be found
          </li>
        </ol>
        <p>
          The Annual Report shall be filed with the records of the Club and a
          copy included in the minutes of the Annual Meeting of Members.
        </p>

        <h4>Section 11. Special Meetings of Members</h4>
        <p>
          Special meetings of Members may be called at any time by the President
          or the Board of Directors for a date and time set by them. The General
          Members may also request that a special meeting be held by delivering
          to the Secretary a written request for a special meeting signed by at
          least fifty (50) General Members in good standing. The request must
          specify the purpose of the meeting and a date and time for the meeting
          that is not less than thirty (30) days from the date the request is
          delivered to the Secretary. The Secretary shall send out notice of a
          special meeting within ten (10) business days after receipt of the
          request.
        </p>

        <h4>Section 12. Place of Member Meetings</h4>
        <p>
          The Board of Directors, in its sole discretion, may determine that
          meetings of Members be held at the principal office of the Club or at
          such other place, within or without the State of New York, as may be
          fixed by the Board of Directors.
        </p>

        <h4>Section 13. Participation in Meetings Remotely</h4>
        <p>
          The Board of Directors, in its sole discretion, may determine that
          meetings of Members be held remotely partially or entirely by means of
          electronic communication. The electronic service or platform shall be
          the place of the Member meeting, if the meeting is held solely by
          means of electronic communication. If the meeting is held partially by
          means of electronic communication, those General Members or their
          proxies participating by electronic means shall be deemed to be
          present at the meeting "in person." Any meeting held by means of
          electronic communication shall include reasonable measures:
        </p>
        <ol>
          <li>
            To verify that each person participating electronically is a Member
            or a proxy of a Member
          </li>
          <li>
            To provide each Member participating electronically with a
            reasonable opportunity to participate in the meeting, including but
            not limited to an opportunity to propose, to object, and, if a
            General Member in good standing, to vote upon a specific action to
            be taken by the Members, and to see, read or hear the proceedings of
            the meeting substantially concurrently with those proceedings
          </li>
          <li>
            To record and maintain a record of any votes or other actions taken
            by electronic communication at the meeting
          </li>
        </ol>

        <h4>Section 14. Notice of Member Meetings</h4>
        <p>
          Notice shall be given of all Member meetings. The notice shall state
          the purpose, place, date, and time of the meeting. The notice shall
          also include, if applicable, information regarding how a Member may
          participate in the meeting by electronic communications (e.g., video
          conference). Notice shall be given at least thirty (30) days prior to
          said meeting.
        </p>

        <h4>Section 15. Waivers of Notice</h4>
        <p>Notice of a meeting need not be given to any Member:</p>
        <ol>
          <li>
            Who submits a signed waiver of notice either before or after the
            meeting
          </li>
          <li>
            Who attends the meeting without protesting the lack of notice to him
            or her prior to or at the start of the meeting
          </li>
        </ol>
        <p>
          Waivers may be provided (a) in a writing signed by the Member or the
          Member's proxy either in hard copy or by affixing a signature by any
          reasonable means (e.g., fax or electronic signature), or (b) by
          e-mail, provided that the transmission of the waiver includes
          information from which the recipient can reasonably determine that the
          transmission was authorized by the individual submitting the waiver.
        </p>
        <h4>Section 16. Qualification of Voters</h4>
        <p>
          Every General Member of record of the Club, in good standing, shall be
          entitled at every Member meeting to one (1) vote. The Board of
          Directors may fix a date as the record date for the purpose of
          determining the General Members entitled to vote at any Member meeting
          or any adjournment thereof, or to express consent to or dissent from
          any proposal without a meeting. The record date shall not be more than
          fifty (50) nor less than ten (10) days before the date of the meeting.
        </p>

        <h4>Section 17. Quorum</h4>
        <p>
          At least one-third (1/3) of the General Members in good standing must
          be present (in person or by proxy) to constitute a quorum for the
          transaction of any business at a Member meeting. When a quorum is once
          present, it is not broken by the subsequent withdrawal of any Members
          or any adjournment of the meeting. If a quorum is not present at a
          Member meeting, the Members present may adjourn the meeting to another
          time and place. Notice of the adjourned meeting shall be provided to
          all Members.
        </p>

        <h4>Section 18. Organization</h4>
        <p>
          At every Member meeting the President, or in the absence of the
          President, the Vice President, or in the absence of such officers, a
          person selected by the Members present, shall function as chairperson
          of the meeting. The Secretary or, in the absence of the Secretary, any
          Assistant Secretary, shall function as secretary of the meeting, and
          in the absence of both the Secretary and any Assistant Secretary, a
          person selected by the Members present shall function as secretary of
          the meeting.
        </p>

        <h4>Section 19. Voting</h4>
        <p>
          Except for the election of Directors and as otherwise required by law,
          the vote of a majority of the General Members in good standing present
          (in person or by proxy) at the meeting at which a quorum is present
          shall constitute action by the Members. Directors shall be elected by
          a plurality of the votes cast at a Member meeting.
        </p>

        <h4>Section 20. Proxies</h4>
        <p>
          Every General Member entitled to vote at a Member meeting may
          authorize another person or persons to act for such General Member by
          proxy. Proxies shall be in a form approved or provided by the Board of
          Directors. Every proxy must be authorized by the General Member or the
          General Member's attorney-in-fact. No proxy shall be valid after the
          expiration of eleven months from the date thereof unless otherwise
          provided in the proxy. Every proxy shall be revocable at the pleasure
          of the General Member executing it, except as otherwise provided by
          law. Proxies may be provided (a) in a writing signed by the General
          Member either in hard copy or (b) by e-mail, provided that the
          transmission of the proxy includes information from which the
          recipient can reasonably determine that the transmission was
          authorized by the individual submitting the proxy. Proxies are not
          assignable.
        </p>

        <h4>Section 21. Inspectors of Election</h4>
        <p>
          The Secretary and a General Member selected by the President shall act
          as inspectors at the meeting or any adjournment thereof. The
          Inspectors shall determine the number of General Members present at
          the meeting, the number of General Members eligible to vote, whether a
          quorum is present at the Member meeting, and the validity and effect
          of proxies. The Inspectors shall receive and count votes, hear and
          determine all challenges and questions arising in connection with the
          right to vote, determine the result, and do such acts as are proper to
          conduct the election or vote with fairness to all Members. Upon
          request of the Chair of the meeting or any General Member present, the
          Inspectors shall make a report in writing of any challenge, question,
          or matter determined and execute a certificate of any fact found. Any
          report or certificate made shall be prima facie evidence of the facts
          stated and of the vote as certified.
        </p>
      </section>

      <section id="article-2">
        <h2>ARTICLE II - BOARD OF DIRECTORS</h2>

        <h4>
          Section 1. Power of Board of Directors and Qualification of Directors
        </h4>
        <p>
          The Board of Directors shall be responsible for the management and
          control of all affairs of the Club, shall elect the Members and
          officers of the Club and, pursuant to Article II Section 3.4 herein,
          fill any vacancies on the Board of Directors. The Board of Directors
          shall have the power to adopt, repeal, and/or amend the House Rules.
          Excepting these By-Laws, the Board of Directors shall also have the
          power to adopt, repeal, and/or amend all further rules affecting the
          management or welfare of the Club, including the admission of Members,
          rights and duties of Members and guests, election of officers, and all
          other matters not otherwise stated herein. Each Director shall be a
          General Member in good standing for at least three (3) years and have
          expressed to the President a willingness to serve on the Board of
          Directors.
        </p>

        <h4>Section 2. Nomination of Directors</h4>
        <p>
          At least one (1) month prior to the Annual Meeting of Members the
          President shall appoint a Nominating Committee. The Nominating
          committee shall be composed of five (5) General Members, two (2) of
          whom shall be current members of the Board of Directors. The
          Nominating Committee shall nominate three (3) candidates for election
          to the Board of Directors. Additional nominations for candidate(s) for
          election to the Board of Directors may be made and seconded by any
          General Member in good standing by complying with the means, manners
          and methods for nominating and seconding candidates adopted by the
          Board of Directors and set forth in the Notice of Meeting. The names
          of all the Nominating Committee's candidates shall be set forth in the
          Notice of Annual Meeting.
        </p>

        <h4>Section 3. Constitution of the Board of Directors</h4>

        <h5>3.1 Number and Term of Office</h5>
        <p>
          The Board of Directors shall consist of nine (9) Directors. The number
          of Directors may be changed by a vote of the majority of the entire
          Board of Directors, provided that no decrease in the number of
          Directors shall shorten the term of any Director. Directors shall
          serve a term of three (3) years. Directors shall be divided into three
          (3) classes of approximately the same size. The General Members in
          good standing shall elect one class of Directors at each Annual
          Meeting of the Members by plurality vote. Directors shall serve until
          their successors are elected and qualified. A Director's term shall
          commence on the next January 1st following the Annual Meeting of
          Members. Between the announcement of their election and January 1st,
          the new Directors shall attend all Board of Directors meetings for the
          purpose of acquainting themselves with the operations and pending
          business of the Club. During this period the newly elected Directors
          shall have no voting powers except for the ability to vote for the
          election of officers for the ensuing year. Retiring Directors shall
          also be eligible to vote in such election of officers.
        </p>

        <h5>3.2 Term Limits</h5>
        <p>
          Directors may serve a maximum of two (2) consecutive full three (3)
          year terms, after which time a Director must be absent from the Board
          of Directors for a minimum of one (1) year before being eligible to
          serve again as a Director.
        </p>

        <h5>3.3 Resignations and Removal of Directors</h5>
        <p>
          Any Director of the Club may resign at any time by giving written
          notice to the President or to the Secretary. Such resignation shall
          take effect at the time specified therein or, if no time be specified,
          then on delivery. The Board of Directors is not required to accept the
          resignation for the resignation to take effect. Any Director may be
          removed by a unanimous vote of the remaining Directors.
        </p>

        <h5>3.4 Vacancies</h5>
        <p>
          All vacant Board of Directors positions shall be filled within two (2)
          months of the effective date of the vacancy by the Board of Directors
          appointing a General Member in good standing (the "Interim
          Appointment"). The term of the Interim Appointment shall expire on the
          31st of December following the next Annual Meeting of Members. The
          remaining term, if any, of the vacant Board of Directors position(s)
          shall be filled by a separate vote of the General Members in good
          standing at the Annual Meeting of Members following the Interim
          Appointment. Nominations for Director(s) to fill the remaining term
          shall be made in the same manner as provided in Article II Section 2
          herein.
        </p>

        <h4>Section 4. Board of Directors Meetings</h4>
        <p>
          Meetings of the Board of Directors may be held without notice and
          shall be held whenever called by the President, or by at least two (2)
          members of the Board of Directors upon written request to the
          Secretary.
        </p>

        <h4>Section 5. Quorum</h4>
        <p>
          (a) Two-thirds (2/3) of the entire Board of Directors shall be a
          quorum for the transaction of business.
        </p>
        <p>
          (b) A majority of the Directors present, whether or not a quorum is
          present, may adjourn any meeting to another time and place without
          notice to any Director.
        </p>

        <h4>Section 6. Voting by the Board of Directors</h4>
        <p>
          (a) As used in these By-Laws, "entire Board of Directors" means the
          actual number of Directors set by the Board.
        </p>
        <p>
          (b) Each Director shall have one (1) vote. Directors shall not vote by
          proxy.
        </p>
        <p>
          (c) Except as set forth in subsections (i), (ii) and (iii) below, the
          vote of a majority of the Directors present at a meeting at which a
          quorum is present shall constitute action by the Board of Directors.
        </p>
        <p>
          (i) The sale, transfer, lease, exchange, mortgage, pledge or other
          disposition of real property or any other item that constitutes all or
          substantially all of the assets of the Club must be approved first by
          two-thirds (2/3) vote of the entire Board of Directors and then
          submitted to the General Members for approval by two-thirds (2/3)
          vote.
        </p>
        <p>
          (ii) Any merger or consolidation of the Club, as well as any
          dissolution of the Club, must be approved first by two-thirds (2/3)
          vote of the Board of Directors present at a meeting at which a quorum
          is present and then submitted to the General Members, who must approve
          such action by two-thirds (2/3) vote.
        </p>
        <p>
          (iii) No monies in excess of $20,000 for any one project or expense,
          unless deemed an emergency expense relating to the functionality of
          the Club or the safety of the Members, will be authorized to be
          expended by the Board of Directors absent the consent of a majority of
          the General Members in good standing. A Special Meeting of the Members
          shall be called by the President to vote on the proposed project or
          expenditure, a description of which shall accompany the Notice of
          Special meeting. A vote of a majority of the General Members in good
          standing, shall be necessary to authorize such project or expenditure,
          provided that the affirmative votes cast in favor of such action shall
          at least equal a quorum.
        </p>

        <h4>Section 7. Board of Directors Vote Without Meeting</h4>
        <p>
          Any action required or permitted to be taken by the Board of Directors
          may be taken without a meeting if all members of the Board of
          Directors consent to the adoption of a resolution authorizing the
          action. The resolution and the written consents of the Directors shall
          be filed with the minutes of the Board of Directors meeting. Consents
          may be provided (a) in a writing signed by the Director either in hard
          copy or by affixing a signature by any reasonable means (e.g., fax or
          electronic signature) or (b) by e-mail, provided that the transmission
          includes information from which the recipient can reasonably determine
          that the transmission was authorized by the Director submitting the
          consent.
        </p>

        <h4>Section 8. Participation in Meetings Remotely</h4>
        <p>
          Any or all Directors or any committee members may participate in a
          meeting by means of a telephone conference, electronic video screen
          communication or similar communications equipment ("Electronic
          Participation"). Electronic Participation may be for the entire
          meeting or only for specific vote(s) provided that before casting his
          or her vote, the Director or committee member(s) participating via
          Electronic Participation was present for the discussion of the
          matter(s) subject to the vote. Electronic Participation shall
          constitute presence "in person" at a meeting provided that all persons
          participating in the meeting can see, read, or hear the proceedings of
          the meeting substantially concurrently with those proceedings, and
          each individual is afforded the opportunity to participate in all
          matters before the Board of Directors or committee, including, but not
          limited to, proposing, objecting to, and voting upon a specific action
          taken at the meeting.
        </p>
      </section>

      <section id="article-3">
        <h2>ARTICLE III - COMMITTEES</h2>

        <h4>Section 1. Committees</h4>

        <h5>1.1 Kinds of Committees & How Constituted</h5>
        <p>
          There shall be a House & Grounds Committee, a Social Committee, a
          Long-Range Planning Committee, a Membership Committee, an Insurance
          Committee, and a Technology Committee. The President shall annually
          submit a list of Chairs for such committees, each of whom shall be a
          member of the Board of Directors. The Board may also from time to time
          select or authorize the appointment of other committees and define
          their powers and duties. The President may do likewise, subject to the
          approval of the Board of Directors.
        </p>

        <h5>1.2 House & Grounds Committee</h5>
        <p>
          The House & Grounds Committee is responsible for the proper upkeep and
          maintenance of the Club facilities and property. Its Chair may appoint
          committee members as he or she deems appropriate.
        </p>

        <h5>1.3 Social Committee</h5>
        <p>
          The Social Committee is responsible for overseeing the complete
          planning and execution of all social functions at the Club. Its Chair
          may appoint committee members as he or she deems appropriate.
        </p>

        <h5>1.4 Long-Range Planning Committee</h5>
        <p>
          The Long-Range Planning Committee shall be comprised of the five (5)
          most recent past Presidents of the Club, the current President, and
          the Chair of the House & Grounds Committee. The President shall serve
          as Chair of this Committee and may appoint such other members as he or
          she deems appropriate. It is the responsibility of this committee to
          make recommendations to the Board of Directors concerning long-range
          facilities planning.
        </p>

        <h5>1.5 Membership Committee</h5>
        <p>
          The Membership Committee shall be chaired by the Vice President and
          shall be responsible for promulgation of rules and procedures to be
          employed by the Club in the application process for new General
          Members, for distributing applications for membership, for receiving
          and reviewing such applications for accuracy and completeness, and for
          presenting the applications for General Membership to the Board of
          Directors for their consideration.
        </p>

        <h5>1.6 Insurance Committee</h5>
        <p>
          The Chair of the Insurance Committee shall be appointed by the
          President. The Insurance Committee shall be responsible for reviewing,
          no less than once a year, all insurance policies in which the Club is
          the named insured, additional insured, or loss payee. The Insurance
          Committee shall make an annual report to the Board of Directors. Such
          report shall provide a list of all insurance coverages/policies then
          in effect as well as the annual premiums associated with said
          insurance coverages/policies. The Insurance Committee shall also
          annually make written recommendations to the Board of Directors
          detailing any proposed additions, deletions, amendments, or
          modifications to the existing insurance coverages/policies that the
          Insurance Committee has determined to be in the best interests of the
          Club.
        </p>

        <h5>1.7 Technology Committee</h5>
        <p>
          The Chair of the Technology Committee shall be appointed by the
          President. The Technology Committee shall be responsible for the
          communication, security, safety, media, and fire prevention needs of
          the Club. The Technology Committee shall investigate, obtain
          quotations from suppliers and contractors, work with the House &
          Grounds Committee, and report its findings and recommendations to the
          Board of Directors as circumstances require.
        </p>

        <h4>Section 2. Committee Meetings</h4>
        <p>
          Meetings may be held without notice and shall be held at such time and
          place as may be fixed by the Chair of the committee or by vote of a
          majority of all the members of the committee. Participation in
          committee meetings remotely is allowed as stated in Article 2, Section
          8.
        </p>

        <h4>Section 3. Quorum and Voting</h4>
        <p>
          Unless otherwise provided by resolution of the Board of Directors:
        </p>
        <ul>
          <li>
            (i) A majority of all of the members of a committee shall constitute
            a quorum for the transaction of business.
          </li>
          <li>
            (ii) The majority vote of committee members present at a meeting at
            which a quorum is present shall constitute action by a committee.
          </li>
        </ul>
        <p>
          The procedures and manner of acting of all committees shall be subject
          at all times to the directions of the Board of Directors.
        </p>

        <h4>Section 4. Tenure of Members of Committees</h4>
        <p>
          Each committee and every committee member shall serve at the pleasure
          of the Board of Directors.
        </p>
      </section>

      <section id="article-4">
        <h2>ARTICLE IV - OFFICERS</h2>

        <h4>Section 1. Officers</h4>
        <p>
          The officers of the Club shall include the President, Vice President,
          Secretary, Treasurer, and such other officers as the Board of
          Directors shall designate.
        </p>

        <h4>Section 2. Election of Officers</h4>
        <p>
          All officers shall be elected by the Board of Directors annually by
          majority vote. The office of President and Vice President shall be
          elected from members of the Board of Directors. The offices of the
          Secretary and Treasurer, as well as any Assistants, shall be elected
          from current-term members of the Board of Directors or past-term
          members of the Board of Directors. If elected from past-term members
          of the Board of Directors, said officer shall have no authority to
          propose any amendment to these By-Laws or to make or second any motion
          at any meeting of the Board of Directors or to vote on any matters
          before the Board of Directors, but shall only fulfill the duties of
          the office to which he or she was elected. All officers shall hold
          office until the election and qualification of their successors.
        </p>

        <h4>Section 3. Duties of President</h4>
        <p>
          The President shall be the chief executive officer of the Club and
          shall exercise such powers and perform such duties as are customary
          and such further powers and duties as are conferred upon him or her by
          these By-Laws and by action of the Board of Directors.
        </p>

        <h4>Section 4. Duties of Vice President</h4>
        <p>
          In the absence of the President, the Vice President shall possess his
          or her powers and perform his or her duties. The Vice President shall
          serve as Chair of the Membership Committee.
        </p>

        <h4>Section 5. Duties of Secretary</h4>
        <p>
          The Secretary shall exercise such powers and perform such duties as
          are customary. He or she shall keep the corporate minutes of the Club.
          It shall be his or her duty to keep up-to-date copies of these By-Laws
          and to present a copy of each to every newly elected Director.
        </p>

        <h4>Section 6. Duties of Treasurer</h4>
        <p>
          The Treasurer shall exercise such other powers and perform such other
          duties as are customary. The Treasurer of the Club shall be charged
          with the collection, custody, and disbursement of the funds of the
          Club. The Treasurer is also charged with maintenance of financial
          records and the creation of reports of all financial activity as
          called for by the Board of Directors and these By-Laws.
        </p>

        <h4>Section 7. Removal of Officers</h4>
        <p>
          Any officer may be removed for cause by a unanimous vote of the
          remaining Directors.
        </p>

        <h4>Section 8. Resignation</h4>
        <p>
          Any officer may resign his or her office at any time by giving written
          notice to the Board of Directors, to the President, or to the
          Secretary. Any such resignation shall take effect at the time
          specified therein, or, if no time be specified, then upon delivery.
          The Board of Directors is not required to accept the resignation for
          the resignation to take effect.
        </p>

        <h4>Section 9. Vacancies</h4>
        <p>The Board of Directors shall fill a vacancy in any office.</p>
      </section>

      <section id="article-5">
        <h2>ARTICLE V - INDEMNIFICATION AND INSURANCE</h2>

        <h4>Section 1. Authorized Indemnification</h4>
        <p>
          Unless clearly prohibited by law or Section 2 of this Article, the
          Club shall indemnify any person ("Indemnified Person") made, or
          threatened to be made, a party in any action or proceeding, whether
          civil, criminal, administrative, investigative, or otherwise,
          including any action by or in the right of the Club, by reason of the
          fact that he or she (or his or her testator or intestate), whether
          before or after adoption of this Section, (a) is or was a Director or
          officer of the Club, or (b) in addition is serving or served, in any
          capacity, at the request of the Club, as a Director or officer of any
          other Club, or any partnership, joint venture, trust, employee benefit
          plan or other enterprise. The indemnification shall be against all
          judgments, fines, penalties, amounts paid in settlement (provided the
          Club shall have consented to such settlement), and reasonable
          expenses, including attorneys' fees and costs of investigation,
          incurred by an Indemnified Person with respect to any such threatened
          or actual action or proceeding, and any appeal thereof.
        </p>

        <h4>Section 2. Prohibited Indemnification</h4>
        <p>
          The Club shall not indemnify any person if a judgment or other final
          adjudication adverse to the Indemnified Person (or to the person whose
          actions are the basis for the action or proceeding) establishes, or
          the Board of Directors in good faith determines, that such person's
          acts were committed in bad faith or were the result of active and
          deliberate dishonesty and were material to the cause of action so
          adjudicated or that he or she personally gained in fact a financial
          profit or other advantage to which he or she was not legally entitled.
        </p>

        <h4>Section 3. Advancement of Expenses</h4>
        <p>
          The Club shall, on request of any Indemnified Person who is or may be
          entitled to be indemnified by the Club, pay, or promptly reimburse the
          Indemnified Person's reasonably incurred expenses in connection with a
          threatened or actual action or proceeding prior to its final
          disposition. However, no such advancement of expenses shall be made
          unless the Indemnified Person makes a binding, written commitment to
          repay the Club, with interest, for any amount advanced for which it is
          ultimately determined that he or she is not entitled to be indemnified
          under the law or Section 2 of this Article.
        </p>

        <h4>Section 4. Indemnification of Others</h4>
        <p>
          Unless clearly prohibited by law or Section 2 of this Article, the
          Board of Directors may approve Club indemnification as set forth in
          Section 1 of this Article or advancement of expenses as set forth in
          Section 3 of this Article, to a person (or the testator or intestate
          of a person) who is or was employed by the Club or who is or was a
          volunteer for the Club, and who is made, or threatened to be made, a
          party in any action or proceeding, by reason of the fact of such
          employment or volunteer activity.
        </p>

        <h4>Section 5. Proceedings Initiated by Indemnified Person</h4>
        <p>
          The Club shall not indemnify or advance expenses to an Indemnified
          Person for any liability or costs incurred in a proceeding or claim
          initiated or brought voluntarily by an Indemnified Person and not by
          way of defense unless such indemnification or advancement of expenses
          is found to be appropriate and is approved by two-thirds (2/3) vote of
          the entire Board of Directors.
        </p>

        <h4>Section 6. Determination of Indemnification</h4>
        <p>
          After termination or disposition of any actual or threatened action or
          proceeding against an Indemnified Person, if indemnification has not
          been ordered by a court of competent jurisdiction, the Board of
          Directors shall, upon written request by the Indemnified Person,
          determine whether and to what extent indemnification is permitted
          pursuant to these By-Laws.
        </p>

        <h4>Section 7. Binding Effect</h4>
        <p>
          Any person entitled to indemnification under these By-Laws has a
          legally enforceable right to indemnification which cannot be abridged
          by amendment of these By-Laws with respect to any event, action, or
          omission occurring prior to the effective date of such amendment.
        </p>

        <h4>Section 8. Insurance</h4>
        <p>
          The Club shall purchase Directors' and Officers' liability insurance
          if authorized and approved by the Board of Directors. To the extent
          permitted by law, such insurance may insure the Club for any
          obligation it incurs as a result of this Article or operation of law,
          and it may directly insure the Directors, officers, employees, or
          volunteers of the Club for liabilities against which they are not
          entitled to indemnification under this Article.
        </p>

        <h4>Section 9. Nonexclusive Rights</h4>
        <p>
          The provisions of this Article shall not limit or exclude any other
          rights to which any person may be entitled under law or contract.
        </p>
      </section>

      <section id="article-6">
        <h2>ARTICLE VI - GENERAL</h2>

        <h4>Section 1. Office</h4>
        <p>
          The office of the Club shall be at such place in the County of
          Cattaraugus, State of New York, as the Board of Directors may
          determine.
        </p>

        <h4>Section 2. Adoption of Policies and Procedures</h4>
        <p>
          The Board of Directors or designated committee of the Board of
          Directors, by resolution, shall adopt such House Rules, regulations,
          policies, and procedures as it may deem necessary and appropriate to
          the operation of the Club, including, but not limited to, a Conflict
          of Interest Policy, provided, however, that no rule, regulation,
          policy, or procedure may be adopted by the Club that is contrary to
          these By-Laws and applicable law as may be amended from time to time.
        </p>

        <h4>Section 3. Interpretation</h4>
        <p>
          The interpretation of the By-Laws and House Rules of the Club and
          their enforcement shall rest solely with the Board of Directors.
        </p>

        <h4>Section 4. Books and Records</h4>
        <p>There shall be kept at the office of the Club:</p>
        <ul>
          <li>Correct and complete books and records of account,</li>
          <li>
            Minutes of the proceedings of the Members and of the Board of
            Directors, and any report created by a committee of the Board of
            Directors,
          </li>
          <li>A current list of the Directors and officers of the Club,</li>
          <li>
            A list of all Members with classes of membership, including names
            and addresses,
          </li>
          <li>A copy of these By-Laws,</li>
          <li>
            A copy of the Club's application for recognition of exemption with
            the Internal Revenue Service,
          </li>
          <li>
            Copies of the past seven (7) years' information returns and form
            990-T's (if any) or any other form required to be filed by any
            federal, state, or local agency,
          </li>
          <li>
            The title search/abstract for any real property owned by the Club.
          </li>
        </ul>

        <h4>Section 5. Fiscal Year</h4>
        <p>
          The fiscal year of the Club shall begin on October 1st and end on
          September 30th.
        </p>
      </section>

      <section id="article-7">
        <h2>ARTICLE VII - AMENDMENTS</h2>

        <p>
          A resolution to enact, amend, or repeal any provision of these By-Laws
          may be proposed by two-thirds (2/3) of the entire Board of Directors
          or upon a written petition signed by one-third (1/3) of the General
          Members in good standing. Notice of any proposed amendment or
          revocation shall be sent to all Members thirty (30) days prior to the
          meeting of the Members (Annual or Special) at which a vote shall be
          taken.
        </p>
        <p>
          On condition that the quorum requirement is satisfied, a resolution to
          enact, amend, or revoke any provision of these By-Laws shall require
          an affirmative vote of two-thirds (2/3) of the votes cast by the
          General Membership in good standing.
        </p>
      </section>
    </Container>
  );
};

export default BylawsScreen;
